import { Reducer } from 'redux';
import uniqBy from 'lodash/unionBy';

import { Itinerary } from '../../types/Itinerary';

import type { ActionType } from './actions';
import { Actions } from './actions';

type ItineraryTemplatesState = {
  cityTemplatesLoading: string[]; // Holds the citySlugs for pending requests
  cityTemplatesLoaded: string[]; // Holds the citySlugs for completed requests
  itineraryTemplates: Itinerary[]; // Holds all the itinerary templates
};

const initialState: ItineraryTemplatesState = {
  cityTemplatesLoading: [],
  cityTemplatesLoaded: [],
  itineraryTemplates: [],
};

// TODO: (fix build workaround) Need to be fixed next time when this code will be changed
// @ts-ignore
export const itineraryTemplatesReducer: Reducer<ItineraryTemplatesState> = (
  state: ItineraryTemplatesState = initialState,
  action: ActionType
): ItineraryTemplatesState => {
  switch (action.type) {
    case Actions.FETCH_CITY_ITINERARY_TEMPLATES:
      return {
        ...state,
        cityTemplatesLoading: [
          ...state.cityTemplatesLoading,
          action.payload.citySlug,
        ],
      };
    case Actions.FETCH_CITY_ITINERARY_TEMPLATES_SUCCESS:
      return {
        ...state,
        cityTemplatesLoading: state.cityTemplatesLoading.filter(
          slug => slug !== action.payload.citySlug
        ),
        cityTemplatesLoaded: [
          ...state.cityTemplatesLoaded,
          action.payload.citySlug,
        ],
        itineraryTemplates: uniqBy(
          [...state.itineraryTemplates, ...action.payload.itineraryTemplates],
          'id'
        ),
      };
    case Actions.ADD_ITINERARY_TEMPLATE:
      return {
        ...state,
        itineraryTemplates: [
          ...state.itineraryTemplates,
          action.payload.template,
        ],
      };
    case Actions.DELETE_ITINERARY_TEMPLATE:
      return {
        ...state,
        itineraryTemplates: [...state.itineraryTemplates].filter(
          item => item.id !== action.payload.id
        ),
      };
    case Actions.UPDATE_ITINERARY_TEMPLATE: {
      const updatedItineraryTemplates = [...state.itineraryTemplates];
      const idx = updatedItineraryTemplates.findIndex(
        item => item.id === action.payload.id
      );
      updatedItineraryTemplates[idx] = {
        ...updatedItineraryTemplates[idx],
        ...action.payload.fields,
      };
      return {
        ...state,
        itineraryTemplates: updatedItineraryTemplates,
      };
    }
    default:
      return state;
  }
};
